/**
 * Fields a Regional Manager may write on a contractor: the resource-type
 * toggles and their capacities (same list as
 * ContractorSubscriber.regionalManagerAllowedUpdateFields in the API). Shared by the API (server-side whitelist on
 * PATCH /contractor/:id/full) and the admin (form save whitelist), so the two
 * cannot drift apart.
 */
export const CONTRACTOR_CAPACITY_FIELDS = [
  'hangerAvailable',
  'hangerCapacity',
  'finisherAvailable',
  'finisherCapacity',
  'sprayerAvailable',
  'sprayerCapacity',
  'trimAvailable',
  'trimCapacity',
  'paintAvailable',
  'paintCapacity',
  'bumperAvailable',
  'bumperCapacity',
  'specialistAvailable',
  'specialistCapacity',
] as const;

export type ContractorCapacityField = typeof CONTRACTOR_CAPACITY_FIELDS[number];
